import { ActivityV2 } from 'models/activityV2'
import {
  NoteEventCard,
  ReminderEventCard,
  SampleEventCard,
  GenericEventCard,
} from './EventCards'

interface EventCardProps {
  event: ActivityV2
  onPreviewRequest?: (sampleId: number) => void
}

/**
 * Router component that delegates to specialized event card components.
 */
export function EventCard({ event, onPreviewRequest }: EventCardProps) {
  // Check if this is a note event
  const isNoteEvent =
    event.content_type.model === 'companynote' ||
    event.content_type.model === 'contactnote' ||
    event.content_type.model === 'doornote'

  // Check if this is a reminder event
  const isReminderEvent = event.content_type.model === 'reminder'

  // Check if this is a sample request event (CREATE or UPDATE)
  const isSampleEvent = event.content_type.model === 'samplerequest'

  // Route to appropriate specialized card
  if (isNoteEvent) {
    return <NoteEventCard event={event} />
  }

  if (isReminderEvent) {
    return <ReminderEventCard event={event} />
  }

  if (isSampleEvent) {
    return <SampleEventCard event={event} onPreviewRequest={onPreviewRequest} />
  }

  // Default to generic card for all other event types
  return <GenericEventCard event={event} />
}
